import 'slick-carousel/slick/slick.min';
import {convert_date_for_ios} from '../components/ios';
import Cookies from 'js-cookie/src/js.cookie';

function get_pharmacy_search_filter() {
  let filter = {};

  let dataFilter = $('.section-pharmacy-search-component').find('.form-pharmacy-search').data('filter');
  if (typeof dataFilter !== 'undefined') {
    filter = {};

    dataFilter = dataFilter.split('|');

    $.each(dataFilter, function (index, element) {
      filter[element] = true;
    });
  }

  return filter;
}

export function set_last_seen_product_cookie($form) {
  if (typeof $form.data('product-id') !== 'undefined') {
    Cookies.set('mea-last-seen-product', $form.data('product-id'));
  }
}

export function set_last_seen_promotion_cookie($form) {
  if (typeof $form.data('promotion-id') !== 'undefined') {
    Cookies.set('mea-last-seen-promotion', $form.data('promotion-id'));
  }
}

export function remove_last_seen_product_cookie_global() {
  if (window.location.pathname.indexOf(mea.pharmacy_search) != 0) {
    Cookies.remove('mea-last-seen-product');
  }
}

export function remove_last_seen_promotion_cookie_global() {
  if (window.location.pathname.indexOf(mea.pharmacy_search) != 0) {
    Cookies.remove('mea-last-seen-promotion');
  }
}

export function remove_last_seen_product_cookie() {
  Cookies.remove('mea-last-seen-product');
}

export function remove_last_seen_promotion_cookie() {
  Cookies.remove('mea-last-seen-promotion');
}

function handle_show_more_link() {
  let $pharmacySearchShowMore = $('.section-pharmacy-search-component').find('.pharmacy-search-result-show-more > a');

  $pharmacySearchShowMore.click(function () {
    set_last_seen_product_cookie($('.section-pharmacy-search-component').find('form.form-pharmacy-search'));
  });
}

function load_pharmacies(location, container, pharmacyLimit) {
  jQuery.ajax({
    type: 'POST',
    url: mea.ajax_url,
    data: {
      action: 'get_dynamic_pharmacies',
      location: location,
      limit: pharmacyLimit,
      filter: get_pharmacy_search_filter(),
      product_id: $(container).find('.form-pharmacy-search').data('product-id'),
      promotion_id: $(container).find('.form-pharmacy-search').data('promotion-id'),
      monthly_product: $(container).find('.form-pharmacy-search').data('monthly-product'),
      monthly_coupon_product: $(container).find('.form-pharmacy-search').data('monthly-coupon-product'),
    },
    dataType: 'json',
    success: function (response) {
      render_pharmacies(response.data, response.settings, container);
      render_position(response.position, container);

      if ($(container).find('.pharmacy-search-result-slider').length > 0) {
        $(container).find('.pharmacy-search-result-slider').slick('refresh');
      }
    },
    error: function (XMLHttpRequest, textStatus, errorThrown) {
      alert(errorThrown);
    },
  });
}

function render_pharmacies(pharmacies, settings, container) {


  let $container = $(container).find('.pharmacy-search-results-container');
  let template = $(container).find('.pharmacy-search-result-clone').html();

  if ($container.hasClass('pharmacy-search-result-slider')) {
    let slideCount = $container.slick('getSlick').slideCount - 2;
    for (let i = slideCount; i >= 0; i--) {
      $container.slick('slickRemove', i);
    }
  } else {
    $container.html('');
  }

  if (Object.keys(pharmacies).length > 0) {
    $.each(pharmacies, function () {
      let res = this;
      let result = template;

      result = result.replace(/{geo_lat}/g, res.geo_lat);
      result = result.replace(/{geo_long}/g, res.geo_long);
      result = result.replace(/{customer_number}/g, res.customer_number);
      result = result.replace(/{url}/g, res.url);
      result = result.replace(/{pharmacy_name}/g, res.pharmacy_name);
      result = result.replace(/{street}/g, res.street);
      result = result.replace(/{number}/g, res.number);
      result = result.replace(/{postcode}/g, res.postcode);
      result = result.replace(/{city}/g, res.city);
      result = result.replace(/{distance}/g, res.distance);
      result = result.replace(/{phone}/g, res.phone);
      result = result.replace(/{chat}/g, res.chat);
      result = result.replace(/{product_price}/g, res.product_price);
      result = result.replace(/{onlineshop}/g, res.onlineshop);
      result = result.replace(/{begin_1}/g, res.begin_1);
      result = result.replace(/{end_1}/g, res.end_1);
      result = result.replace(/{begin_2}/g, res.begin_2);
      result = result.replace(/{end_2}/g, res.end_2);
      result = result.replace(/{emergency_service_begin}/g, (res.emergency_service_begin == null) ? '' : res.emergency_service_begin);
      result = result.replace(/{emergency_service_end}/g, (res.emergency_service_end == null) ? '' : res.emergency_service_end);

      if(res.product_retail_price) {
        result = result.replace(/{product_retail_price}/g, res.product_retail_price);
      }
      if(res.product_retail_price_type) {
        result = result.replace(/{product_retail_price_type}/g, res.product_retail_price_type);
      }
      if(res.product_calculated_price) {
        result = result.replace(/{product_calculated_price}/g, res.product_calculated_price);
      }
      if(res.product_calculated_unit) {
        result = result.replace(/{product_calculated_unit}/g, res.product_calculated_unit);
      }

      result = $(result);

      if (res.chat == '') {
        $(result).find('.btn-chat').remove();
      }

      if (settings.monthly_product == true && res.product_price != null && res.product_shop_link != '') {
        $(result).find('.pharmacy-search-shop-link').removeClass('d-none');

        let avpText  = '';
        if(res.product_retail_price_type && res.product_retail_price) {
          avpText = '<span class="product-retail-price">' + res.product_retail_price_type + '<sup>1</sup>: <s>' + res.product_retail_price + '€</s></span>';
        }

        let regulationText  = '';
        if(res.product_calculated_price && res.product_calculated_unit) {
          regulationText = '<span class="product-regulation-data">' + res.product_calculated_price + '€ / ' + res.product_calculated_unit + '</span>';
        }

        $(result).find('.pharmacy-search-shop-link > a').html(avpText + 'Für ' + res.product_price + '€ im Shop kaufen<sup>*</sup>' + regulationText).attr('href', res.product_shop_link);
      } else if (settings.monthly_product == true && res.product_price != null && res.product_shop_link == '') {
        $(result).find('.pharmacy-search-shop-link').removeClass('d-none');

        let avpText  = '';
        if(res.product_retail_price_type && res.product_retail_price) {
          avpText = '<span class="product-retail-price">' + res.product_retail_price_type + '<sup>1</sup>: <s>' + res.product_retail_price + '€</s></span>';
        }

        let regulationText  = '';
        if(res.product_calculated_price && res.product_calculated_unit) {
          regulationText = '<span class="product-regulation-data">' + res.product_calculated_price + '€ / ' + res.product_calculated_unit + '</span>';
        }

        $(result).find('.pharmacy-search-shop-link > a').html(avpText + 'Für ' + res.product_price + '€ vor Ort kaufen<sup>*</sup>' + regulationText).attr('href', res.url);
      } else if ((settings.monthly_coupon_product == true || settings.filter['monthly-coupons'] == true) && res.coupon_url != '') {
        $(result).find('.pharmacy-search-shop-link').removeClass('d-none');
        $(result).find('.pharmacy-search-shop-link > a').html('Coupon anzeigen').attr('href', res.coupon_url);
      } else if (res.product_shop_link != '') {
        $(result).find('.pharmacy-search-shop-link').removeClass('d-none');
        $(result).find('.pharmacy-search-shop-link > a').attr('href', res.product_shop_link);
      } else {
        $(result).find('.pharmacy-search-shop-link').remove();
      }

      if (res.onlineshop == '') {
        $(result).find('.btn-shop').remove();
      }

      if (typeof res.distance == 'undefined') {
        $(result).find('.pharmacy-distance').remove();
      }

      $container.append(result);
    });

    render_opening_hours($container.find('.pharmacy-search-result'));
  }
}

function render_position(position, container) {
  let $container = false;
  let $pharmacySearchShowMore = $(container).find('.pharmacy-search-result-show-more > a');

  if($(container).find('.pharmacy-search-result-headline').length > 0) {
    $container = $(container).find('.pharmacy-search-result-headline');

    $container.removeClass('ssc');
    $container.find('.ssc-line').remove();
    // $container.find('.find-pharmacy').removeClass('d-none');
  }

  let url = mea.pharmacy_search;


  if (typeof position == 'undefined' || position === false) {
    if($container.length > 0){
      $container.find('.results-not-found').removeClass('d-none');
    }
    url += '/';
  } else {
    if($container.length > 0) {
      let template = $container.find('.results-found').html();

      $container.find('.results-found').html(template.replace(/{position}/g, position.postcode + ' ' + position.city));
      $container.find('.results-found').removeClass('d-none');
    }

    url += encodeURI(position.lat + ',' + position.lng) + '/';
  }

  let filter = get_pharmacy_search_filter();
  if (typeof $(this).data('filter') !== 'undefined') {
    let filter = $(this).data('filter').split('|');

    $.each(filter, function (index, key) {
      $.each(mea.pharmacy_search_filter, function (indexFilter, element) {
        if (element.key == key) {
          url += encodeURI(element.url) + '/';
          return false;
        }
      });
    });
  }

  if (Object.keys(filter).length > 0) {
    $.each(filter, function (key, value) {
      if (String(value) == 'true') {
        $.each(mea.pharmacy_search_filter, function (indexFilter, element) {
          if (element.key == key) {
            url += encodeURI(element.url) + '/';
            return false;
          }
        });
      }
    });
  }

  $pharmacySearchShowMore.attr('href', url);
}

export function render_opening_hours($results) {
  let currentDate = new Date();
  let currentTime = ('0' + (currentDate.getHours())).slice(-2) + ':' + ('0' + (currentDate.getMinutes())).slice(-2);

  let currentDateTomorrow = new Date();
  let currentDateAfterTomorrow = new Date();

  currentDateTomorrow.setDate(currentDateTomorrow.getDate() + 1);
  currentDateAfterTomorrow.setDate(currentDateAfterTomorrow.getDate() + 2);

  if ($results.length > 0) {
    $.each($results, function () {
      let begin_1 = $(this).data('begin-1');
      let end_1 = $(this).data('end-1');
      let begin_2 = $(this).data('begin-2');
      let end_2 = $(this).data('end-2');
      let emergency_service_begin = $(this).data('emergency-service-begin');
      let emergency_service_end = $(this).data('emergency-service-end');

      let emergencyEndDateText = '';
      if (typeof emergency_service_begin != 'undefined' && emergency_service_begin != '' && typeof emergency_service_end != 'undefined' && emergency_service_end != '') {
        let emergencyEndDate = convert_date_for_ios(emergency_service_end);
        let emergencyEndMonth = ('0' + (emergencyEndDate.getMonth() + 1)).slice(-2);
        let emergencyEndDay = ('0' + (emergencyEndDate.getDate())).slice(-2);
        let emergencyText = emergencyEndDay + '.' + emergencyEndMonth;

        if (emergencyEndDate.getFullYear() == currentDate.getFullYear() && emergencyEndDate.getMonth() == currentDate.getMonth() && emergencyEndDate.getDate() == currentDate.getDate()) {
          emergencyText = 'heute';
        } else if (emergencyEndDate.getFullYear() == currentDateTomorrow.getFullYear() && emergencyEndDate.getMonth() == currentDateTomorrow.getMonth() && emergencyEndDate.getDate() == currentDateTomorrow.getDate()) {
          emergencyText = 'morgen';
        } else if (emergencyEndDate.getFullYear() == currentDateAfterTomorrow.getFullYear() && emergencyEndDate.getMonth() == currentDateAfterTomorrow.getMonth() && emergencyEndDate.getDate() == currentDateAfterTomorrow.getDate()) {
          emergencyText = 'übermorgen';
        }

        emergencyEndDateText = (emergencyText + ' ' + ('0' + (emergencyEndDate.getHours())).slice(-2) + ':' + ('0' + (emergencyEndDate.getMinutes())).slice(-2));
      }

      if (emergency_service_begin != '' && emergency_service_end != '') {
        $(this).find('.pharmacy-opening-hours').html('Geöffnet bis ' + emergencyEndDateText + ' Uhr (Notdienst)');
      } else {
        if ((begin_1 != '' && end_1 != '' && currentTime >= begin_1 && currentTime <= end_1)) {
          $(this).find('.pharmacy-opening-hours').html('Geöffnet bis ' + end_1 + ' Uhr');
        } else if ((begin_2 != '' && end_2 != '' && currentTime >= begin_2 && currentTime <= end_2)) {
          $(this).find('.pharmacy-opening-hours').html('Geöffnet bis ' + end_2 + ' Uhr');
        } else {
          $(this).find('.pharmacy-opening-hours').html('Aktuell geschlossen');
        }
      }
    });
  }
}

function pharmacy_search_geolocation(container, pharmacyLimit) {
  if (navigator.geolocation) {
    if (navigator.permissions) {
      navigator.permissions.query({name: 'geolocation'}).then(function (permissionStatus) {
        if (permissionStatus.state == 'granted') {
          navigator.geolocation.getCurrentPosition(function (position) {
            load_pharmacies({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            }, container);
          }, function error() {
            load_pharmacies(false, container, pharmacyLimit);
          }, {
            enableHighAccuracy: false,
            timeout: 5000,
          });
        } else {
          load_pharmacies(false, container, pharmacyLimit);
        }
      })
    } else {
      load_pharmacies(false, container, pharmacyLimit);
    }
  } else {
    load_pharmacies(false, container);
  }
}

export function pharmacy_search_component() {
  if ($('.section-pharmacy-search-component').length > 0) {
    $('.section-pharmacy-search-component').each(function(){
      let pharmacyLimit = 6;
      if ($(this).find('.pharmacy-search-result-slider').length == 0) {
        pharmacyLimit = 3;
      }

      if (!$(this).hasClass('compact')) {
        pharmacy_search_geolocation(this, pharmacyLimit);
        handle_show_more_link(this);
      }

      if ($(this).find('.pharmacy-search-result-slider').length > 0) {
        let slidesToShow = 3;
        if ($(this).find('.pharmacy-search-result-slider').parents('.container').hasClass('container-small')) {
          slidesToShow = 2;
        }

        $(this).find('.pharmacy-search-result-slider').slick({
          dots: false,
          infinite: false,
          slidesToShow: slidesToShow,
          prevArrow: '<button type="button" class="slick-prev slick-arrow" aria-label="Zurück" role="button"><i class="far fa-angle-left"></i></button>',
          nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Weiter" role="button"><i class="far fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '30px',
              },
            },
          ],
        });
      }
    });
  }
}




// WEBPACK FOOTER //
// ./scripts/components/pharmacy-search-component.js